import { useEffect } from "react";
import "./HomePageGoldGarageDoor.module.css";
import Header from "@/reusable_sections/Header";
import NavigationHeader from "./sections/NavigationHeader";
import HeroSection from "./sections/HeroSection";
import TrustCredibilityStrip from "./sections/TrustCredibilityStrip";
import MobileStickyCtaBar from "./sections/MobileStickyCtaBar";
import Servicesshowcase from "./sections/Servicesshowcase";
import Manufacturermarquee from "./sections/Manufacturermarquee";
import Customerreviews from "./sections/Customerreviews";
import WhyChooseUs from "./sections/WhyChooseUs";
import InteractiveProcessAccordion from "./sections/InteractiveProcessAccordion";
import ServiceAreas from "./sections/ServiceAreas";
import TwoColumnFaq from "./sections/TwoColumnFaq";
import BrandFooter from "./sections/BrandFooter";
import Readytobegin from "./sections/Readytobegin";
export default function HomePageGoldGarageDoorPage() {
  useEffect(() => {
    const scriptId = "gold-garage-schema";
    let script = document.getElementById(scriptId) as HTMLScriptElement;
    if (!script) {
      script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.innerHTML = JSON.stringify({
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Gold Garage Door",
        "telephone": "+61485000933",
        "email": "goldgaragedoor1@gmail.com",
        "url": "https://goldgaragedoor.com.au",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "",
          "addressLocality": "Sydney",
          "addressRegion": "NSW",
          "addressCountry": "AU"
        },
        "areaServed": "Sydney, NSW",
        "knowsAbout": ["Garage Door Installation", "Garage Door Repair", "Garage Door Maintenance", "Overhead Door Services", "Emergency Garage Door Service", "Commercial Garage Doors"],
        "hoursOfOperation": {
          "@type": "OpeningHoursSpecification",
          "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
          "opens": "00:00",
          "closes": "23:59"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "5.0",
          "reviewCount": "267"
        }
      });
      document.head.appendChild(script);
    }
    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);
  return <div className="pb-20 md:pb-0">
      <Header />
      <NavigationHeader />
      <HeroSection />
      <TrustCredibilityStrip />
      <Servicesshowcase />
      <Manufacturermarquee />
      <Customerreviews />
      <WhyChooseUs />
      <MobileStickyCtaBar />
      <InteractiveProcessAccordion />
      <ServiceAreas />
      <TwoColumnFaq />
      <Readytobegin />
      <BrandFooter />
    </div>;
}